<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" sm="1">
        <router-link
          :to="{ name: 'InsuranceQuote', hash: '#insurance' }"
          class="back-arrow"
          ><v-icon large color="mid-grey" class="mt-1">{{
            icons.mdiArrowLeft
          }}</v-icon></router-link
        >
      </v-col>
      <v-col cols="12" sm="10">
        <h1 class="my-2">Important information</h1>
        <h3>
          You’re nearly there! Before you check out, here’s some important stuff
          to note.
        </h3>
        <p>
          (It’s important that you also read the full T&amp;Cs, which you can
          access below, and which we’ll send you once you’ve completed the
          sign-up process.)
        </p>
        <h3>Insurer</h3>
        <p>
          The policy is underwritten by Old Mutual Alternative Risk Transfer
          Limited (“OMART”), a licensed life insurance cell captive insurer, and
          a member of Old Mutual Limited group of companies.
          <br />
          Postal address: PO Box 66, Cape Town, 8000
          <br />
          Telephone; 021 504 6423
        </p>
        <h3>QuickWill</h3>
        <p>
          QuickWill (Pty) Ltd Reg No 2020/604318/07, QuickWill are authorised
          and mandated to render financial services as a Juristic Representative
          of Shackleton Life, an authorised financial services provider, FSP No
          44723.
          <br />
          Postal Address: Postnet Suite # 65, Postnet Three Anchor Bay, 7
          Penarth Road, Three Anchor Bay, Cape Town, 8005
          <br />
          Telephone: 011 084 7735
        </p>
        <h3>Shackleton Life</h3>
        <p>
          Shackleton Life (Pty) Ltd Reg No 1998/022545/07 a licensed and
          authorised financial services provider, FSP No: 44723. Shackleton Life
          distributes the product online through QuickWill its juristic
          representative and performs the binder functions which include the
          claims settlement and Policy administration of this Policy, which have
          been outsourced to it by OMART.
        </p>
        <h3>Replacement Polices</h3>
        <p>
          If this policy is to replace any other policy with another assurer,
          then kindly note in this event you may contact your Financial Advisor
          who will assist you with a detailed comparison.
          <br />
          <a :href="whitelabel.insuranceTermsPdfLocation" target="_blank"
            >Click here</a
          >
          for the full list of T&amp;C's.
        </p>
        <h3>Financial Advice</h3>
        <p>
          You have chosen the death benefit yourself and have not received any
          comprehensive advice from QuickWill or Shackleton Life regarding the
          application for this policy. QuickWill and Shackleton Life does not
          provide comprehensive financial advice as defined by the Financial
          Services and Intermediary Services Act (FAIS). Should you require
          comprehensive financial advice, Financial Needs Analysis or a detailed
          comparison between products you may consult a qualified Financial
          Planner who will assist you in this regard.
          <br />
          <a :href="whitelabel.insuranceTermsPdfLocation" target="_blank"
            >Click here</a
          >
          for the full list of T&amp;C's.
        </p>
        <h3>Remuneration</h3>
        <p>
          Commission in terms of the Long Term Insurance Act is paid to the
          Intermediary, Shackleton Life, the amount of commission paid is
          disclosed in the Policy Schedule. All fees are included in the monthly
          premium which includes binder fees of 9% of the total monthly/annual
          premium paid to Shackleton Life.
        </p>
        <h3>Personal Information</h3>
        <p>
          By accepting the terms and conditions, you consent to QuickWill
          receiving and storing your personal information. We will keep this
          data secure and confidential and will only share it with third parties
          to manage your policy better or if required to do so by law.
          <br />
          <a :href="whitelabel.insuranceTermsPdfLocation" target="_blank"
            >Click here</a
          >
          for the full list of T&amp;C's.
        </p>
        <h3>Cooling Off Period</h3>
        <p>
          The Life Assured has 31 days from receipt of the Policy to decide to
          cancel the policy with no penalties, provided that no death or claims
          have taken place during this period. All premiums already paid will be
          refunded.
          <br />
          <a :href="whitelabel.insuranceTermsPdfLocation" target="_blank"
            >Click here</a
          >
          for the full list of T&amp;C's.
        </p>
        <h3>Term (Whole of Life)</h3>
        <p>
          The policy is a whole of life policy, which means that there is no
          term associated with the policy and that it can be kept for your whole
          life as long as you continue to pay the monthly premiums.
          <br />
          <a :href="whitelabel.insuranceTermsPdfLocation" target="_blank"
            >Click here</a
          >
          for the full list of T&amp;C's.
        </p>
        <h3>Grace Period</h3>
        <p>
          A period of one calendar month calculated from the premium payment
          date chosen by the Life Assured in the Policy Schedule, which will be
          allowed for the payment of each premium. If the premium is not paid
          within the Grace Period the policy will lapse. The Grace Period does
          not apply to the payment of the first premium. If the first premium is
          not paid as required, the Policy will lapse.
          <br />
          <a :href="whitelabel.insuranceTermsPdfLocation" target="_blank"
            >Click here</a
          >
          for the full list of T&amp;C's.
        </p>
        <h3>Nominate a Beneficiary</h3>
        <p>
          This is the person who will be responsible for paying for your
          family’s expenses in the event of your death. The sum you are assured
          for will be paid directly to their bank account.
          <br />
          <a :href="whitelabel.insuranceTermsPdfLocation" target="_blank"
            >Click here</a
          >
          for the full list of T&amp;C's.
        </p>
        <h3>Reinstatement</h3>
        <p>
          Should the Policy lapse it may be reinstated within six (6) months of
          such lapse, subject to the recommencement of all Waiting Periods and
          Exclusions in terms of the Policy Wording and any such terms and
          conditions as OMART may impose at the time of reinstatement.
          <br />
          <a :href="whitelabel.insuranceTermsPdfLocation" target="_blank"
            >Click here</a
          >
          for the full list of T&amp;C's.
        </p>
        <h3>Absence from the Republic of South Africa</h3>
        <ul>
          <li>
            If you’re planning on leaving the Republic of South Africa for more
            than 90 consecutive days for non-holiday purposes please notify us
            before your leaving. If OMART is not informed, OMART may decline the
            claim within the period of your absence and the cover may cease.
          </li>
          <li>
            OMART reserves the right to cancel the Policy if not notified of the
            Life Assured leaving the Republic of South Africa.
          </li>
        </ul>
        <br />
        <h3>Complaints</h3>
        <p>
          Should you be dissatisfied about any matter relating to the policy or
          to any service provided or offered by OMART or Shackleton Life you may
          contact the appropriate Complaints Department as follows:
        </p>
        <h3>OMART</h3>
        <p>
          Compliance Officer: 021 509 3113 Complaints:
          omartcomplaints@oldmutual.com
        </p>
        <h3>Shackleton Life (Pty) Ltd: Policy Administration and Claims</h3>
        <p>
          Postal Address; PO Box 2264, Durban, 4000 Telephone: 087 232 7014
          Compliance Department email compliance@shackletonlife.co.za
        </p>
        <a :href="whitelabel.insuranceTermsPdfLocation" target="_blank"
          >Click here</a
        >
        for the full list of T&amp;C's.
        <v-btn
          class="center-insurance-button"
          rounded
          depressed
          large
          color="primary"
          center
          @click="$router.push({ name: 'InsuranceBankingDetails' })"
        >
          <span>Next</span><v-icon small>{{ icons.mdiArrowRight }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'InsuranceImportantInfo',
    data() {
      return {
        publicPath: process.env.BASE_URL,
      };
    },
  };
</script>
